import React, { useEffect, useRef, useState } from "react";
import { fetchHomelocalexpertList } from "../services/Localocalexpertlist";
import { API_BASE } from "../api/apiConfig";

const Localocalexpertlist = () => {
  const [experts, setExperts] = useState([]);
  const sliderRef = useRef(null);

  useEffect(() => {
    loadExperts();
  }, []);

  const loadExperts = async () => {
    const res = await fetchHomelocalexpertList();
    if (res?.status) setExperts(res.data);
  };

  const scroll = (dir) => {
    if (!sliderRef.current) return;
    sliderRef.current.scrollBy({
      left: dir === "left" ? -320 : 320,
      behavior: "smooth",
    });
  };

  return (
  <section className="relative w-full bg-slate-50 py-10 md:py-24 featured-experts-section">
    <div className="absolute left-0 top-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl animate-pulse-soft"></div>
    <div className="absolute bottom-0 right-0 h-64 w-64 rounded-full bg-primary/5 blur-3xl animate-pulse-soft"></div>

    <div className="container mx-auto px-4 md:px-6">

      {/* HEADER */}
      <div className="mb-10 md:mb-12">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <div className="inline-flex items-center border h-10 rounded-full border-green-200 bg-green-50 text-green-700 px-3 py-1 text-xs font-medium mb-6">
              <span className="mr-2 h-1.5 w-1.5 rounded-full bg-primary animate-pulse-soft"></span>
              Featured Experts
            </div>
            <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3">
              Meet Our <span className="text-gradient">Top-Rated</span> Travel Experts
            </h2>
            <p className="text-base text-gray-600 max-w-2xl">
              Discover our most experienced and highly-rated travel experts ready to help you plan your perfect journey.
            </p>
          </div>

          <div className="flex items-center gap-2 text-sm font-medium">
            <a href="/experts" className="text-green-600 hover:text-green-700 flex items-center">
              View all experts →
            </a>
          </div>
        </div>
      </div>

      {/* SLIDER */}
      <div className="relative -mx-4 px-4">
        <button onClick={() => scroll("left")} className="customPrevBtn absolute -left-2 top-1/2 z-10 h-10 w-10 -translate-y-1/2 rounded-full border bg-white shadow hover:scale-110">
          ‹
        </button>

        <div ref={sliderRef} className="flex gap-4 overflow-x-auto pb-4 scrollbar-hide">
          {experts.map((expert, index) => (
            <div key={expert.id || index} className="flex-shrink-0 w-[280px]">
              <div className="bg-white rounded-lg overflow-hidden shadow-sm border hover:shadow-md transition">

                {/* IMAGE */}
                <div className="relative h-48 overflow-hidden">
                  <img
                    src={expert.profile_image ? `${API_BASE}${expert.profile_image}` : "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/attachments/gen-images/public/member-1-bOpGjZCsPuoiXPcWozfOLLcloeHRto.jpg"}
                    alt={expert.name}
                    className="absolute inset-0 w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent" />

                  <div className="absolute top-3 right-3 flex items-center bg-green-500 text-white rounded-full px-2 py-1 text-xs font-semibold">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-star h-3 w-3 fill-current mr-1"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg> {expert.rating || "4.9"}
                  </div>

                  <div className="absolute top-3 left-3 flex items-center text-white text-sm">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-map-pin h-4 w-4 mr-1"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"></path><circle cx="12" cy="10" r="3"></circle></svg> {expert.city || "Delhi"}
                  </div>

                  <div className="absolute bottom-3 left-3 right-3">
                    <h3 className="font-bold text-white text-lg mb-2">{expert.name}</h3>
                    <div className="flex items-center">
                      <span className="bg-white/90 text-gray-800 px-2 py-1 rounded text-xs font-medium mr-2">
                        {expert.expert?.[0]?.mealtype || "Himalayan Treks"}
                      </span>
                      <span className="bg-gray-100/90 text-gray-700 px-2 py-1 rounded text-xs">+1</span>
                    </div>
                  </div>
                </div>

                {/* FOOTER */}
                <div className="p-4">
                  <a href={`/experts/${expert.slug || ""}`} className="inline-flex items-center text-green-600 hover:text-green-700 font-medium text-sm mb-2">
                    View Profile →
                  </a>
                  <p className="text-gray-600 text-sm line-clamp-2">
                    {expert.description || "Himalayan Treks, Adventure expert"}
                  </p>
                </div>

              </div>
            </div>
          ))}
        </div>

        <button onClick={() => scroll("right")} className="customNextBtn absolute -right-2 top-1/2 z-10 h-10 w-10 -translate-y-1/2 rounded-full border bg-white shadow hover:scale-110">
          ›
        </button>
      </div>
    </div>
  </section>
);

};

export default Localocalexpertlist;
